"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    isArrayOfIncreasingNumbers: ()=>isArrayOfIncreasingNumbers,
    defaultAmounts: ()=>defaultAmounts,
    getMenuItems: ()=>getMenuItems
});
const isArrayOfIncreasingNumbers = (value, minAmount)=>{
    if (!Array.isArray(value) || value.length < 2 || value.length > 5) {
        return false;
    }
    for(let i = 0; i < value.length - 1; i++){
        if (typeof value[i] !== 'number' || value[i] <= minAmount || value[i] >= value[i + 1]) {
            return false;
        }
    }
    return true;
};
const defaultAmounts = [
    20,
    30,
    40,
    50,
    60
];
const getMenuItems = (merchant, giftCardPresetAmounts, maxAmount, minAmount)=>{
    let MENU_ITEMS_AMOUNTS = defaultAmounts;
    if (giftCardPresetAmounts && isArrayOfIncreasingNumbers(giftCardPresetAmounts, minAmount)) {
        MENU_ITEMS_AMOUNTS = giftCardPresetAmounts;
    }
    // when restrictions are on, drop any preset above the allowed max — otherwise
    // the dropdown could offer a value the purchase would reject. Applies to merchant
    // presets too, not just the defaults. `<=` so a preset equal to the max stays.
    if (merchant?.gift_card_restrictions) {
        MENU_ITEMS_AMOUNTS = MENU_ITEMS_AMOUNTS.filter((value)=>value <= maxAmount);
    }
    return MENU_ITEMS_AMOUNTS;
};
